<template>
	<JonInfo>
		<template #message>
			<p class="font-weight-extra-bold">
				Jede Software, die du beherrscht, erhöht deine Chancen - daher erfasse alles!
			</p>
			<p>
				Zum Beispiel Programme für Grafik, Programmiersprachen, Buchhaltung, Musikbearbeitung, Konstruktion,
				Design, Produktion, Logistik und alle anderen. - Zum Beispiel BMD, SAP FI, Adobe Premiere, AutoCAD,
				Java, AutoCad.
			</p>
		</template>
	</JonInfo>
</template>

<script>
import JonInfo from "@/vue/common/JonInfo.vue";

export default {
	components: {JonInfo}
}
</script>
